import React, { useState, useCallback } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import { GOOGLE_MAPS_LOADER_OPTIONS } from "../utils/googleMaps";

export default function LocationCard({ latitude, longitude, label, senderName }) {
  const { isLoaded } = useJsApiLoader(GOOGLE_MAPS_LOADER_OPTIONS);

  const [map, setMap] = useState(null);
  const center = { lat: latitude, lng: longitude };
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&travelmode=walking`;

  const onLoad = useCallback((m) => setMap(m), []);
  const onUnmount = useCallback(() => setMap(null), []);

  return (
    <div className="rounded-lg overflow-hidden border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 max-w-[220px]">
      <div className="w-full h-[130px]">
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '130px' }}
            center={center}
            zoom={15}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
              streetViewControl: false,
              mapTypeControl: false,
              fullscreenControl: false,
              gestureHandling: 'none',
              zoomControl: false,
            }}
          >
            {map && <Marker position={center} />}
          </GoogleMap>
        ) : (
          <div className="w-full h-full bg-gray-200 dark:bg-gray-700 animate-pulse" />
        )}
      </div>
      <div className="p-2 flex flex-col gap-0.5">
        <span className="text-xs text-gray-500 dark:text-gray-400">{senderName} shared a location</span>
        {label && <span className="text-xs text-gray-700 dark:text-gray-200">📍 {label}</span>}
        <a
          href={directionsUrl}
          className="text-xs text-blue-600 dark:text-blue-400 underline mt-0.5"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          Get Directions
        </a>
      </div>
    </div>
  );
}
